import React from 'react';
import { LiveBlogFilter } from '../../state/types';
import { Spinner } from '../../../../moderation-v2/comments-and-posts/dashboard/components';

interface Props {
  isLoading: boolean;
  timeFilter: LiveBlogFilter;
  onTimeFilterChange: (timeFilter: LiveBlogFilter) => void;
}

const EmptyList: React.FC<Props> = ({ isLoading, timeFilter, onTimeFilterChange }) => {
  return isLoading ? (
    <Spinner size={'normal'} gapSize={'large'} />
  ) : (
    <div className={'live-events-empty-list'}>
      <span>
        There are no events scheduled.
        <br />
        This is the perfect time to create one :)
      </span>
    </div>
  );
};

export default EmptyList;
